import { createSlice } from '@reduxjs/toolkit';
import OfferDetails from '../../pages/recruitment/offer/offer-details';

type Compensation = {
    uuid: string, 
    isVariable: boolean, 
    compensationType: string, 
    compensationSubType: string, 
    index: number,
    formulaBasedOn?: string,
}

type DialogInitialValues = {
    isOpen: boolean
    type: string
    isFullScreen?: boolean
    dialogTitle?: string
    defaultForm?: string
    status?: string
    id?: number | null
    payload?: any
    title?: string
    onboardDetails?: any
    OfferDetails?: any
    clockInDate?: string
    clockOutDate?: string
    rowStatus?: string
    uploadDocumentFile:any
    updateApproverStatus: boolean
    updatepayload: any
    route?: string
    isDeduction? :boolean
    compensation? : Compensation | null
    notification_id?: any
}

const initialState: DialogInitialValues = {
    isOpen: false, type: '', isFullScreen: false, dialogTitle: '', status: '', defaultForm: '', id: null, payload: null,updatepayload: null, onboardDetails: null, OfferDetails: null,uploadDocumentFile:[],updateApproverStatus: false, route: '', isDeduction: false, compensation : null, notification_id: '' 
};

const dialogSlice = createSlice({
    name: 'dialog',
    initialState,
    reducers: {
        openDialog: (state, action) => {
            return { ...state, isOpen: true, ...action.payload }
        },
        closeDialog: (state) => {
            return { ...initialState }
        },
    },
});

export const { openDialog, closeDialog } = dialogSlice.actions;

export default dialogSlice.reducer;
